import React from 'react';
import { useTranslation, Trans } from 'react-i18next';

function Hero({ onNavigate }) {
  const { t } = useTranslation();
  const trustedBy = [
      {src: 'imgs/logo-ikea.png', alt: 'ikea'},
      {src: 'imgs/logo-hochland.png', alt: 'hochland'},
      {src: 'imgs/logo-jti.png', alt: 'jti'},
      {src: 'imgs/logo-wff.png', alt: 'wff'},
      {src: 'imgs/logo-steelseries.png', alt: 'steelseries'},
      {src: 'imgs/logo-otomoto.png', alt: 'otomoto'},
      {src: 'imgs/logo-rainbow.png', alt: 'rainbow'},
  ];
  
  return (
    <section className="section hero-section" id="hero">
      <div className="hero-content">
        <span className="hero-logo">
            <img src="/imgs/icon.png" alt="OUROBOROS logo"/>
            {t('hero.logo')}
        </span>
        <h1 className="hero-title">{t('hero.title')}</h1>
        <h2 className="hero-subtitle">{t('hero.subtitle')}</h2>
        <p className="hero-tagline"><Trans i18nKey={t('hero.tagline')} /></p>
        <div className="hero-buttons">
            <a href="#contact" className="btn-primary">{t('hero.buttonPilot')}</a>
            <a href="#philosophy" className="btn-secondary">{t('hero.buttonSeeHowWorks')} ↓</a>
        </div>
        <div className="hero-trusted">
            <p>{t('hero.trustedBy')}</p>
            <div className="hero-trusted-by">
                {trustedBy.map((logo, index) => (
                    <img
                        key={index}
                        src={`/${logo.src}`}
                        alt={`${logo.alt}`}
                        className="client-logo"
                    />
                ))}
            </div>
        </div>
      </div>
    </section>
  );
}

export default Hero;
